<template>
  <div class="onboarding-tour">
    <ReportIntroPartV2 :loading="loading" />
  </div>
</template>

<script>
// components
import ReportIntroPartV2 from '@/pages/report/components/onboarding/parts/ReportIntroPartV2'

export default {
  name: 'OnboardingTour',
  components: {
    ReportIntroPartV2,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.page-wrapper:has(.footer-menu-wrapper) .v-step {
  z-index: 98;
}
</style>

<style scoped>
.onboarding-tour::v-deep .v-step {
  padding: 0;
  border-radius: 12px;
  background: var(--Basic-900, #091540);
  box-shadow: 0px 199px 56px 0px rgba(0, 0, 0, 0),
    0px 128px 51px 0px rgba(0, 0, 0, 0.01),
    0px 72px 43px 0px rgba(0, 0, 0, 0.05), 0px 32px 32px 0px rgba(0, 0, 0, 0.09),
    0px 8px 18px 0px rgba(0, 0, 0, 0.1);
}
.onboarding-tour::v-deep .v-step__content {
  display: flex;
  padding: 0px 16px 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  text-align: initial;
  margin: 0;
  font-size: var(--Size-M, 14px);
  font-weight: 500;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}

.onboarding-tour::v-deep .actions__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  padding: 16px;
  width: 100%;
}
.onboarding-tour::v-deep .actions__steps-counter {
  color: var(--Basic-A-800, rgba(255, 255, 255, 0.64));
  font-size: var(--Size-S, 12px);
  font-weight: 600;
  line-height: var(--Line-Height-S, 16px);
}
.onboarding-tour::v-deep .actions__buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.onboarding-tour::v-deep .actions__buttons::v-deep .gl-button {
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
  border-radius: 8px;
  height: 40px;
  padding: 0px 12px;
}

.onboarding-tour::v-deep .actions__buttons .btn-skip {
  background-color: transparent;
  border: none;
}
</style>
